<template>
    <div>
        <h6>
            Yearly Safety Data:
            <template v-if="editMode">
                <i v-if="!safetyYears || safetyYears.length < clientYearsRequired" class="fa fa-asterisk text-danger small"></i>
                <button type="button" class="btn btn-sm btn-info" v-on:click="newOshaYear()" title="Add Yearly Safety Data"><i class="fa fa-plus-circle"></i></button><br>
                <small>Enter the last {{ this.clientYearsRequired }} years of data. <span v-if="false">({{ requiredOshaYears.join(", ") }})</span></small>
                <br>
                <small>If you are exempt and not required to submit data to OSHA, contact {{ this.account_name }} <template v-if="this.sub_contact_email">at {{ this.sub_contact_email }} </template>with your request and NAICS code. They will be able to mark you as exempt. <a href="https://www.osha.gov/recordkeeping/ppt1/RK1exempttable.html" target="_blank">Click here</a> to verify that your company is an exempt industry before requesting exemption by {{ this.account_name }}.</small>
            </template>
        </h6>

        <button type="button" class="btn btn-sm btn-info" @click="showLegend = !showLegend">{{this.showLegend ? 'Hide' : 'Show'}} OSHA Calculation Formulas</button><br><br>

        <template v-if="showLegend">
            <div class="alert alert-info" style="white-space: pre-wrap;">
                <ul>
                    <li>Fatalities: OSHA 300A - Item G</li>
                    <li>Lost Work Day Cases: OSHA 300A - Item H</li>
                    <li>Job Transfer or Restriction Cases: OSHA 300A - Item I</li>
                    <li>Other Recordable Cases: OSHA 300A - Item J</li>
                    <li>Recordable Incident Rate: Formula = (Total Recordable Cases x 200,000) / Total Hours Worked</li>
                </ul>
            </div>
        </template>

         <osha-year-modal ref="subSafetyYearModal" :subcontractorId="subcontractorId" v-if="editMode" />

         <b-table bordered striped hover small responsive :items="safetyYears" :fields="fields">
             <template v-slot:cell(subcontractor_id)="data">
                 <button type="button" class="btn btn-sm btn-link" v-on:click="editOshaYear(data.item)" title="Edit Safety Year"><i class="fa fa-edit"></i></button>
             </template>

             <template v-slot:cell(osha_file_id)="data">
                <span v-if="data.item.osha_file_id">
                    <a :href="`/files/download/${data.item.osha_file_id}`" target="_blank" title="Download OSHA 300A Form">{{ data.item.osha_file.file_name }}</a>
                    <span v-if="editMode">
                        |&nbsp;<a href="javascript:void(0)" @click="deleteFile(data.item.sub_osha_year_id)" class="text-danger">Delete</a>
                    </span>
                </span>
             </template>
         </b-table>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            },

            years: {
                type: Array,
                default: null,
            },

        },

        data: function() {
            return {
                safetyYears: this.years ? this.years : this.$store.state.subcontractor.safetyYears,
                clientYearsRequired: this.$store.state.user.sub_years_required,
                account_name: this.$store.state.user.account_name,
                sub_contact_email: this.$store.state.user.sub_contact_email,
                showLegend: false,
            }
        },

        computed: {
            fields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'subcontractor_id', label: 'Edit'},
                        {key: 'osha_year', label: 'Year'},
                        {key: 'emr', label: 'EMR'},
                        {key: 'fatalities', label: 'Fatalities'},
                        {key: 'cited_fatalities', label: 'Cited Fatalities'},
                        {key: 'lost_work_days', label: 'Lost Work Day Cases'},
                        {key: 'transfer_restriction_cases', label: 'Job Transfer or Restriction Cases'},
                        {key: 'other_recordable_cases', label: 'Other Recordable Cases'},
                        {key: 'total_recordable_cases', label: 'Total Recordable Cases'},
                        {key: 'hours_worked', label: 'Employee Hours Worked'},
                        {key: 'incident_rate', label: 'Recordable Incident Rate'},
                        {key: 'first_aid_cases', label: 'First Aid Cases'},
                        {key: 'osha_file_id', label: 'OSHA 300A'},
                    ];
                }

                return [
                    {key: 'osha_year', label: 'Year'},
                    {key: 'emr', label: 'EMR'},
                    {key: 'fatalities', label: 'Fatalities'},
                    {key: 'cited_fatalities', label: 'Cited Fatalities'},
                    {key: 'lost_work_days', label: 'Lost Work Day Cases'},
                    {key: 'transfer_restriction_cases', label: 'Job Transfer or Restriction Cases'},
                    {key: 'other_recordable_cases', label: 'Other Recordable Cases'},
                    {key: 'total_recordable_cases', label: 'Total Recordable Cases'},
                    {key: 'first_aid_cases', label: 'First Aid Cases'},
                    {key: 'hours_worked', label: 'Employee Hours Worked'},
                    {key: 'dart', label: 'DART'},
                    {key: 'incident_rate', label: 'Recordable Incident Rate'},
                    {key: 'osha_file_id', label: 'OSHA 300A'},

                ];
            },

            requiredOshaYears(){
                //Eventually Replace these with dates
                var clientQualificationExpires = this.$store.state.user.sub_expire_date;

                //SEtup variables
                var now = new Date();
                var startYear = now.getFullYear() - 1;
                var expires = new Date(now.getYear() + '-' + (clientQualificationExpires));
                var requiredYears = [];

                //Check the expiration date for the rollover
                //Example, if it's January 20th, 2019, still require 2017,2016,2015.
                //Once the expiration date has hit, start requiring the immediate
                //previous year. Example, February 20th, 2019 we start requiring 2018,2017,2016
                if(now.getMonth() < expires.getMonth() || (now.getMonth() == expires.getMonth() && now.getDate() < expires.getDate()))
                {
                    startYear--;
                }

                //Start the process
                for (var i = this.clientYearsRequired ; i > 0; i--)
                {
                    requiredYears.push((startYear--));
                }

                //SEnd it
                return requiredYears;
            }
        },

        methods: {
            deleteFile(id) {
                this.$http.post(`subcontractors/child-files-delete/osha_year/${id}`)
                .then(response => {
                    this.$toastr.success('300A Form Removed');
                    for (let i = 0; i < this.safetyYears.length; i++)
                    {
                        if (this.safetyYears[i].sub_osha_year_id == id)
                        {
                            this.safetyYears[i].osha_file = null;
                            this.safetyYears[i].osha_file_id = null;
                            this.$store.commit('setSafetyYears', this.safetyYears);
                        }
                    }
                })
            },

            newOshaYear(){
                //Set the prop
                this.$refs.subSafetyYearModal.setModel({});

                //Activate the modal
                this.$refs.subSafetyYearModal.showModal();
            },

            editOshaYear(year){
                //Set the prop
                this.$refs.subSafetyYearModal.setModel(year);

                //Activate the modal
                this.$refs.subSafetyYearModal.showModal();
            },

            // deleteBid(bid){
            //     //Check for confirm
            //     if(!confirm('Are you sure you want to delete this bid?'))
            //     {
            //         return;
            //     }

            //     //Send it
            //     this.$http
            //         .post('/subcontractors/bid/delete/' + bid.bid_id)
            //         .then(response => {
            //             //Alert
            //             this.$toastr.success('Bid Deleted');

            //             //Delete the bid
            //             //this.updatebids(desig, true);
            //             this.$store.commit('deleteBid', bid);
            //         });
            // },
        },

        mounted() {

        }
    }
</script>